import { AppNS } from 'app';
import { API_URL } from 'app/core/config';
import axios, { Canceler } from 'axios';

import { getErrorMessage } from '../helpers/errorHandling';
import { prepareAvailableDates } from './inspectors-parsers';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function getAvailability(
  params: AppNS.Params
): Promise<AppNS.InspectorAvailability> {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/inspectors/availability.json`, { params })
      .then(({ data }) => {
        if (data) {
          resolve(prepareAvailableDates(data));
        } else {
          reject('Invalid response data');
        }
      })
      .catch((error) => {
        reject(getErrorMessage(error));
      });
  });
}

export function createInspector(reqData: AppNS.Params): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/inspectors.json`, reqData)
      .then(({ data }) => {
        if (data.user) {
          resolve(data);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
}

export function getInspector(id: string): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/inspectors/${id}.json`)
      .then(({ data }) => {
        if (data.user) {
          resolve(data.user);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response);
      });
  });
}

export function getInspectors(params: any): Promise<AppNS.Params> {
  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/inspectors.json`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        params,
      })
      .then(({ data }) => {
        if (data.results) {
          resolve(data);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}

export function setPersonalDetails(
  reqData: AppNS.Params
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/inspectors/personal-details.json`, reqData)
      .then(({ data }) => {
        if (data.user) {
          resolve(data.user);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}
export function apiToggleDeactivation(
  action: 'activate' | 'deactivate',
  reqData: AppNS.Params
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/inspectors/${action}.json`, reqData)
      .then(({ data }) => {
        if (data.user) {
          resolve(data.user);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}

export function setEmploymentDetails(
  reqData: AppNS.Params
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/inspectors/employment-details.json`, reqData)
      .then(({ data }) => {
        if (data.user) {
          resolve(data.user);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}

export function setAvailability(reqData: AppNS.Params): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/inspectors/availability.json`, reqData)
      .then(({ data }) => {
        if (data.user) {
          resolve(data.user);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}
export function setUnavailablePeriods(
  reqData: AppNS.Params
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/inspectors/unavailable-periods.json`, reqData)
      .then(({ data }) => {
        if (data.user) {
          resolve(data.user);
        } else {
          reject(data.errors);
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}
